// The pager under a messaging list that is not a table: the inbox's thread
// list and the unverified mail (spec 17 §4.1, §4.2). It is the shared
// `ListPager` (D-560) in the messaging area's own classes; the templates
// catalog is a DataTable and uses that table's own pager instead.

import { ListPager, type ListPagerProps } from "../../../../components/list-pager";

export function MsgPager(props: Omit<ListPagerProps, "className" | "rangeClassName">) {
  return <ListPager {...props} className="msg-toolbar msg-pager" rangeClassName="msg-hint" />;
}
